import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'loading',
  templateUrl: './loading.component.html',
  inputs: ['message']
})
export class LoadingComponent implements OnInit {

	public message:string = 'Loading...';

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./client/app/loading/loading.component.ts